import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultPage from './Pages/DefaultPage';
import SsoVsManualAudit from './Components/SsoVsManualAudit';

const AuditRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={`${path}/sso-vs-manual`}>
                <SsoVsManualAudit />
            </Route>
            <Route default>
                <DefaultPage />
            </Route>
        </Switch>
    );
};

export default AuditRouter;
